import React, { Component } from "react";
import { connect } from "react-redux";
import "./infoTable.css";

class InfoTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { dataSouse = [], cols = 3, className, itemClassName,valueStyle={} } = this.props;
    return (
      <div className={`InfoTable_container ${className}`}>
        {dataSouse.map((item, index) => (
          <InfoRow key={index} className="Row_distance" cols={cols} dataRow={item} itemClassName={itemClassName} valueStyle={valueStyle}/>
        ))}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    SupperFundHome: state.SupperFundHome,
  };
}
export default connect(mapStateToProps)(InfoTable);

class InfoRow extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  getColor = (value,key) => {
    const noColor = [ "运行周期", "运作起始日期"];
    const green = ['近一年最大回撤','组合最大回撤'];
    if (noColor.includes(key)||value==='--') return "#333";
    if(green.includes(key)) return '#1DA96B'
    if (value.replace("%", "") >= 0) return "#F8515C";
    return "#1DA96B";
  };
  render() {
    const { cols, dataRow = [], className, itemClassName,valueStyle } = this.props;
    console.log('valueStyle',valueStyle)
    return (
      <div className={`InfoRow_container  ${className}`}>
        {dataRow.map((item, index) => {
          const value=item[0]||'--';
          const key=item[1];
          return (
            <div key={index} className={`InfoRow_item${cols} ${itemClassName}`} style={{ width: `calc(100% / ${cols})` }}>
              <div className="InfoRow_value" style={Object.assign({color: this.getColor(value,key)},valueStyle)}>
                {value}
              </div>
              <div className="InfoRow_tip">{key}</div>
            </div>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/InfoTable.js